import { EnvironmentProviders, InjectionToken, inject, makeEnvironmentProviders } from '@angular/core';
import { FirebaseApp, FirebaseOptions, initializeApp } from 'firebase/app';
import { AppCheck, ReCaptchaEnterpriseProvider, initializeAppCheck } from 'firebase/app-check';

export const FIREBASE_APP = new InjectionToken<FirebaseApp>('Firebase App');
export const FIREBASE_APP_CHECK = new InjectionToken<AppCheck>('Firebase App Check');

export function provideFirebaseServices(options: FirebaseOptions, reCaptchaSiteKey: string): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: FIREBASE_APP, useFactory: () => initializeApp(options) },
    {
      provide: FIREBASE_APP_CHECK,
      useFactory: () => initializeAppCheck(inject(FIREBASE_APP), {
        provider: new ReCaptchaEnterpriseProvider(reCaptchaSiteKey),
        isTokenAutoRefreshEnabled: true,
      }),
    },
  ]);
}
